// based on https://auth0.com/blog/complete-guide-to-react-user-authentication/
import { Auth0Provider as BaseAuth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';

import { getAuth0Config } from './config';
import { useAuthRedirectCallback } from './useAuthRedirectCallback';

export function Auth0Provider({ children }: { children: ReactNode | ReactNode[] }) {
  const { audience, scope, clientId, domain, redirectUri, authorizeTimeoutInSeconds, httpTimeoutInSeconds } =
    getAuth0Config();
  const handleAuthRedirect = useAuthRedirectCallback();

  return (
    <BaseAuth0Provider
      authorizationParams={{ redirect_uri: redirectUri, audience, scope }}
      httpTimeoutInSeconds={httpTimeoutInSeconds}
      authorizeTimeoutInSeconds={authorizeTimeoutInSeconds}
      cacheLocation='localstorage'
      onRedirectCallback={(appState) => {
        handleAuthRedirect({ appState, currentPath: location.pathname });
      }}
      useRefreshTokens
      useRefreshTokensFallback
      clientId={clientId}
      domain={domain}
    >
      {children}
    </BaseAuth0Provider>
  );
}
